import { clearTokenAction } from '@tshio/redux-api-auth-middleware';
import { connect } from 'react-redux';
import { compose, Dispatch } from 'redux';

import { Logout } from './Logout';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onClearToken: () => dispatch(clearTokenAction()),
});

export const LogoutContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(Logout);
